import { render, staticRenderFns } from "./PictureAlbum.vue?vue&type=template&id=e6f5d704&"
import script from "./PictureAlbum.vue?vue&type=script&lang=js&"
export * from "./PictureAlbum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports